//import Libraries
import React, { Component } from 'react';
import {connect} from 'react-redux';
import {storageRef} from '../../../../../firebase'
import PropTypes from 'prop-types';

//import Components
import {Row, Col, Button, Form} from 'reactstrap';
import CategorySelector from '../../../../../components/CategorySelector/CategorySelector';

import ProductCheckFormGroup from './Elements/ProductCheckFormGroup';
import ProductInputFormGroup from './Elements/ProductInputFormGroup';
import ProductNumberFormGroup from './Elements/ProductNumberFormGroup';
import ProductTypeFormGroup from './Elements/ProductTypeFormGroup';

import ImageSelector from '../../../Components/ImageSelector/ImageSelector';
import EditConfirmButton from '../../../Components/EditConfirmButton/EditConfirmButton';

import UpDownButton from '../../../Components/UpDownButton/UpDownButton'

import * as productActions from './actions/productActions';
import * as imageActions from '../../../actions/imageActions';
import * as validations from './InputValidation';

//import Styles
import './Product.css'
// import { storage } from 'firebase';
// import { debug } from 'util';

class Product extends Component {
    constructor(props) {
        super(props);

        const { category, name, description, prices, types, order} = props.product;

        this.state = {
            editing : false,
            mainCategory : category.mainCategory < 0 ? 0 : category.mainCategory,
            subCategory : category.subCategory < 0 ? 0 : category.subCategory,
            koName : name['ko'],
            enName : name['en'],
            koDescription : description['ko'],
            enDescription : description['en'],
            order : order === undefined ? this.props.index : order,

            prices : prices === undefined ? [] : prices,
            types : types === undefined ? [] : types,

            showingIndex : 0,
        }
    }

    componentDidUpdate = (prevProps, prevState, snapshot) => {
        if(prevProps.product.id !== this.props.product.id) {
            const { category, name, description, prices, types, order, index} = this.props.product;

            this.setState({
                mainCategory : category.mainCategory < 0 ? 0 : category.mainCategory,
                subCategory : category.subCategory < 0 ? 0 : category.subCategory,
                koName : name['ko'],
                enName : name['en'],
                koDescription : description['ko'],
                enDescription : description['en'],
                order : order === undefined ? index : order,

                prices : prices === undefined ? [] : prices,
                types : types === undefined ? [] : types,

                showingIndex : 0
            })
        }
    }

    canRegisterProduct = ()=> {
        const { koName, enName, koDescription, enDescription } = this.state;

        const koNameGood = validations.checkTextInput(koName);
        const enNameGood = validations.checkTextInput(enName);
        const koDescGood = validations.checkTextInput(koDescription);
        const enDescGood = validations.checkTextInput(enDescription);

        return (koNameGood && enNameGood && koDescGood && enDescGood)
    }

    addDefaultTypePrice = () => {
        let newPrices = [...this.state.prices];
        let newTypes = [...this.state.types];

        newPrices.push(9999);
        newTypes.push('새로운 타입');
        this.setState({
            prices : newPrices,
            types : newTypes
        })
    }

    toggleEditing = () => {
        if(this.state.editing) {
            this.props.makeEditDoneAnything();
            this.setState({
                editing : false
            })
        } else {
            if(this.props.makeEditAnything()) {
                this.setState({
                    editing : true
                })
            }
        }
    }

    handleUpdateProduct = () => {
        const {mainCategory, subCategory, 
                koName, enName, 
                koDescription, enDescription, 
                prices, types,
                order, file} = this.state;
        const id = this.props.product.id;

        let numberPrices = new Array(prices.length);
        for(let i = 0; i < numberPrices.length; ++i) {
            numberPrices[i] = Number(prices[i]);
        }

        this.props.onUpdateProduct({
            id, 
            category : {
                mainCategory,
                subCategory
            },
            name : {
                ko : koName,
                en : enName,
            },
            description : {
                ko : koDescription,
                en : enDescription
            },
            prices : numberPrices,
            types,

            order,
            file
        });
    }

    handleOnChange= (e) => {
        this.setState({
            [e.target.name] : e.target.value
        });
    }

    handleOnCategorySelectorChange = (e) => {
        this.setState({
            [e.target.name] : parseInt(e.target.value)
        });
    }

    handleOnTypeChange = (index) => {
        this.setState({
            showingIndex : index
        });
    }

    handleOnTypeTextChange = (e) => {
        let newTypes = [...this.state.types];
        newTypes[this.state.showingIndex] = e.target.value;
        this.setState({
            types : newTypes
        });
    }

    handleOnPriceTextChange = (e) => {
        let newPrices = [...this.state.prices];
        newPrices[this.state.showingIndex] = e.target.value;
        this.setState({
            prices : newPrices
        })
    } 

    handleOnRemove = (index) => {
        let newTypes = [...this.state.types];
        let newPrices = [...this.state.prices];

        newTypes.splice(index, 1);
        newPrices.splice(index, 1);
        
        this.setState({
            types : newTypes,
            prices : newPrices
        });
    }

    render() {
        const {id} = this.props.product;
        const {editing} = this.state;

        const mainCategory = this.state.mainCategory;
        const subCategory = this.props.category.subCategory[this.state.mainCategory] ? this.props.category.subCategory[this.state.mainCategory] : undefined;

        const canRegisterProduct = this.canRegisterProduct();
        return(
            <div className="product">
                <div className="IndexLabel">{this.props.index + 1}</div>
                <Row>
                    <Col sm={2}>
                        <ImageSelector 
                            storagePath="product_images"
                            imageId={id}
                        />
                    </Col>
                    <Col>
                        <ProductInputFormGroup 
                            label="이름"
                            type="text"
                            name="koName"
                            value={this.state.koName}
                            onChange={this.handleOnChange}
                            disabled={!editing}
                        />
                        <ProductInputFormGroup 
                            label="설명"
                            type="textarea"
                            name="koDescription"
                            value={this.state.koDescription}
                            onChange={this.handleOnChange}
                            disabled={!editing}
                        />
                    </Col>
                    <Col>
                        <ProductInputFormGroup 
                            label="Name"
                            type="text"
                            name="enName"
                            value={this.state.enName}
                            onChange={this.handleOnChange}
                            disabled={!editing}
                        />
                        <ProductInputFormGroup 
                            label="Description"
                            type="textarea"
                            name="enDescription"
                            value={this.state.enDescription}
                            onChange={this.handleOnChange}
                            disabled={!editing}
                        />
                    </Col>
                    <Col sm={3}>
                        <ProductTypeFormGroup
                            label="종류"
                            name="selectingType"
                            onRemove={this.handleOnRemove}
                            onShowingTypeChange={this.handleOnTypeChange}
                            onAddNewDefault={this.addDefaultTypePrice}
                            onTextChange={this.handleOnTypeTextChange}
                            types={this.state.types}
                            disabled={!editing}
                        />
                        <ProductNumberFormGroup
                            label="가격"
                            name="price"
                            onChange={this.handleOnPriceTextChange}
                            value = {this.state.prices[this.state.showingIndex]}
                            disabled={!editing}
                        />
                    </Col>
                    {
                        this.props.editCategory && (
                            <div>
                                <CategorySelector
                                    name="mainCategory"
                                    label="대분류"
                                    options={this.props.category.mainCategory}
                                    handleOnChange={this.handleOnCategorySelectorChange}
                                    value={this.state.mainCategory}
                                    disabled={!editing}
                                    initialValue="0"
                                />
                                <CategorySelector
                                    name="subCategory"
                                    label="소분류"
                                    options={subCategory}
                                    handleOnChange={this.handleOnCategorySelectorChange}
                                    value={this.state.subCategory}
                                    disabled={!editing}
                                    initialValue="0"
                                />
                            </div>
                        )
                    }
                    <Col sm={1}>
                        <UpDownButton 
                            disabled={this.props.editAnything}
                            onOrderUp={() => {
                                if(this.props.prevProductGlobalIndex !== null && this.props.makeEditAnything()) {
                                    this.props.onProductOrderSwitch(this.props.product.globalIndex, this.props.prevProductGlobalIndex);
                                    this.props.makeEditDoneAnything();
                                }
                            }}
                            onOrderDown={() => {
                                if(this.props.nextProductGlobalIndex !== null && this.props.makeEditAnything()) {
                                    this.props.onProductOrderSwitch(this.props.product.globalIndex, this.props.nextProductGlobalIndex);
                                    this.props.makeEditDoneAnything();
                                }
                            }}
                        />
                        <EditConfirmButton
                            editing={editing}
                            onConfirm={ () => {
                                this.handleUpdateProduct();
                            }}
                            onToggleEditing={() => {
                                this.toggleEditing();
                            }}
                            onRemove={() => {
                                if(this.props.makeEditAnything()) {
                                    this.props.makeEditDoneAnything();
                                    this.props.onRemoveProduct(id, this.state.mainCategory, this.state.subCategory)
                                }
                            }}

                        />
                    </Col>
                </Row>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        category : state.category,
    }
}

const mapDispatchToProps  = (dispatch) => {
    return {
        onUpdateProduct : (info) => {
            dispatch(productActions.updateProduct(info));
        },
        onRemoveProduct : (id, mainCategory, subCategory) => {
            dispatch(productActions.removeProduct(id, mainCategory, subCategory));
        },
        onProductOrderSwitch : (aIndex, bIndex) => {
            dispatch(productActions.productOrderSwitch(aIndex, bIndex));
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Product);

Product.propTypes = {
    editCategory : PropTypes.bool
}

Product.defaultProps = {
    editCategory : false
}



// WEBPACK FOOTER //
// ./src/pages/Admin/ProductManager/Category/Product/Product.js